<template>
    <b-form-group class="mb-0">
        <b-form-input
            id="product-quantity"
            v-if="edit"
            type="text"
            size="sm"
            v-model.number="value"
            v-numeric-only
            v-validate="{required: true, min_value:1, regex:/^\d+$/}"
            name="quantity"
            :class="{'is-invalid': errors.has('quantity') || availableProduct < value}"
            @input="onInputHandler" />
        <b v-else>{{value}}</b>
        <b-form-invalid-feedback :state="!availableProduct < value"><b>Available:</b> {{availableProduct}}</b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import { numericOnly } from '@/directives/numericOnly'
    import { inputTypeTimer } from '@/utils'
    export default {
        name: 'QuantityColumn',
        props: {
            edit: {
                type: Boolean,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            endpoint: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                value: this.item.orderedQuantity,
                timeOut: null
            }
        },
        computed: {
            availableProduct () {
                return this.item.product.stock.available
            },
        },
        directives: {
            numericOnly
        },
        created() {
            this.value = this.item.orderedQuantity
            this.$nextTick(() => this.$validator.validateAll())
        },
        methods: {
            onInputHandler() {
                this.$validator.validateAll()
                this.$emit('input', {
                    productId: this.item.product.id,
                    quantity: this.value
                })
            },
        },
        watch: {
            item: {
                deep: true,
                handler(nextPropsItem, prevPropsItem) {
                    this.value = nextPropsItem.orderedQuantity
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form-group {
        position: relative;
    }
    .invalid-feedback {
        position: absolute;
        top: 30px;
        left: 0;
        font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Orders/SingleOrder/QuantityColumn.vue